import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, errMsg } from "../api";
import { Btn, Notice } from "./ui";

const RESULT: Record<string, { kind: "ok" | "error"; text: string }> = {
  vinculado: { kind: "ok", text: "Conta Google vinculada. Agora você também pode entrar com o Google." },
  outra_conta: { kind: "error", text: "Essa conta Google já está vinculada a outro usuário." },
  ja_tem: { kind: "error", text: "Seu usuário já tem uma conta Google vinculada." },
  nao_verificado: { kind: "error", text: "O e-mail dessa conta Google não está verificado." },
};

/** Configurações › Login com Google: vincula uma conta Google ao usuário atual (pede a senha de novo). Os dados financeiros continuam só no MM Money. */
export function GoogleLink({ realm }: { realm: "pf" | "pj" }) {
  const [sp, setSp] = useSearchParams();
  const [st, setSt] = useState<{ enabled: boolean; linked: boolean; email: string | null } | null>(null);
  const [msg, setMsg] = useState<{ kind: "ok" | "error"; text: string } | null>(RESULT[sp.get("google") ?? ""] ?? null);
  const [asking, setAsking] = useState(false); const [pw, setPw] = useState(""); const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (sp.get("google")) { const n = new URLSearchParams(sp); n.delete("google"); setSp(n, { replace: true }); }
    api<{ enabled: boolean; linked: boolean; email: string | null }>("GET", `/api/${realm}/auth/google/link/status`).then(setSt).catch(() => setSt(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [realm]);
  if (!st?.enabled) return null;
  async function go() {
    setBusy(true); setMsg(null);
    try { const r = await api<{ url: string }>("POST", `/api/${realm}/auth/google/link/start`, { password: pw }); window.location.assign(r.url); }
    catch (e) { setMsg({ kind: "error", text: errMsg(e) }); setBusy(false); }
  }
  return (
    <div className="card" style={{ maxWidth: 560, marginBottom: 16 }} data-google-link>
      <h3 style={{ fontSize: 16, marginBottom: 6 }}>Login com Google</h3>
      <p className="muted" style={{ marginTop: 0 }}>O Google só confirma quem é você (nome e e-mail). Seus dados financeiros ficam apenas no MM Money.</p>
      {msg && <Notice kind={msg.kind}>{msg.text}</Notice>}
      {st.linked ? <p>Conta Google vinculada: <strong>{st.email}</strong></p> : asking ? (
        <form onSubmit={(e) => { e.preventDefault(); void go(); }} style={{ display: "grid", gap: 8 }}>
          <label>Confirme sua senha do MM Money<input type="password" autoComplete="current-password" value={pw} onChange={(e) => setPw(e.target.value)} required /></label>
          <div style={{ display: "flex", gap: 8 }}><Btn type="submit" disabled={busy || !pw}>Continuar com o Google</Btn><Btn type="button" variant="ghost" onClick={() => { setAsking(false); setPw(""); }}>Cancelar</Btn></div>
        </form>
      ) : <Btn onClick={() => setAsking(true)}>Vincular conta Google</Btn>}
    </div>
  );
}
